<template>
  <CheckMeBack :customer="customer" :instrument="instrument" v-if="type=='InstrumentUltimateTzCheckMeBack'" />
  <Government :customer="customer" :instrument="instrument" v-else-if="type=='InstrumentUltimateTzGovernment'" />
  <SalaryAdvance :customer="customer" :instrument="instrument" v-else />
</template>

<script>
import CheckMeBack from "@/views/customers/partners/ultimate_tz/components/checkMeBack/Pay"
import Government from "@/views/customers/partners/ultimate_tz/components/government/Pay"
import SalaryAdvance from "@/views/customers/partners/ultimate_tz/components/salaryAdvance/Pay"

export default {

  components: { CheckMeBack, Government, SalaryAdvance },

  props: {
    instrument: {
      type: Object,
      required: false,
    },
    customer: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },

}
</script>
